import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { numberToPixel } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/Styling/conversions";
import { ContentWidth } from "@faire/web-api--source/indigofair/data/ContentWidth";
var _obj;
var contentWidthToPixels = (_obj = {}, _define_property(_obj, ContentWidth.DESKTOP_STANDARD, 1280), _define_property(_obj, ContentWidth.DESKTOP_LARGE, 1376), _define_property(_obj, ContentWidth.DESKTOP_XLARGE, 1920), _obj);
export var getContentWidthPixels = function() {
    var contentWidth = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ContentWidth.CONTENT_WIDTH_UNKNOWN;
    var _numberToPixel;
    return (_numberToPixel = numberToPixel(contentWidthToPixels[contentWidth])) !== null && _numberToPixel !== void 0 ? _numberToPixel : "none";
};
